import { render } from "./ExampleDeviceScreenFacebook.vue?vue&type=template&id=6288e810&scoped=true&ts=true&lang=pug"
import script from "./ExampleDeviceScreenFacebook.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExampleDeviceScreenFacebook.vue?vue&type=script&lang=ts&setup=true"

import "./ExampleDeviceScreenFacebook.vue?vue&type=style&index=0&id=6288e810&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6288e810"]])

export default __exports__